import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { getCurrentUser } from 'shared/graphql/queries/user/getUser';

const NoUsernameHandler = props => {
  const { data, location, history } = props;
  const { user } = data;
  if (!user) return null;
  if (user && user.username) return null;
  const { pathname, search } = location;
  if (pathname === '/new/user') return null;
  history.replace({
    pathname: '/new/user',
    state: { redirect: `${pathname}${search}` },
  });
  return null;
};

export default compose(getCurrentUser, withRouter)(NoUsernameHandler);
